import React, { Component } from 'react';
import './index.css';


class Select extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedLang: this.props.options ? this.props.options[0] : null,
      showDialog: false
    }
    this.titleClickHandler = this.titleClickHandler.bind(this);
    this.selsctClickHandler = this.selsctClickHandler.bind(this);
    this.handleClickOutside = this.handleClickOutside.bind(this);
    this.setWrapperRef = this.setWrapperRef.bind(this);
  }

  titleClickHandler(e){
    this.setState({showDialog: !this.state.showDialog});
  }

  selsctClickHandler(selectedLang){
    this.setState({selectedLang, showDialog: false});
    this.props.onChange(selectedLang);
  }

  setWrapperRef(node) {
    this.wrapperRef = node;
  }

  handleClickOutside(event){
    if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
      this.setState({showDialog: false})
    }
  }

  componentDidMount() {
    document.addEventListener('mousedown', this.handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside);
  }


  render() {
    const { options, optionsClass, selectClass, containerClass, titleClass, iconClass, textClass } = this.props;
    const { selectedLang, showDialog } = this.state;
    return (
      <div ref={this.setWrapperRef} className={containerClass ? containerClass + ' select-container' : 'select-container'}>
        <div className={titleClass ? titleClass + ' select-title-container' : 'select-title-container'}>
          <div className='select-title' onClick={this.titleClickHandler}>
            {selectedLang ? selectedLang.icon : null}
            { showDialog ? <span style={{marginLeft:'2px'}} className="bp3-icon bp3-icon-chevron-up"></span>
              :<span style={{marginLeft:'2px'}} className="bp3-icon bp3-icon-chevron-down"></span>
            }
          </div>
        </div>
        {
          showDialog && <ul className={selectClass ? optionsClass +' options-container' : 'options-container'}>
          {options.map((item, index)=>{
            return (
              <li key={item+index} className={optionsClass ? optionsClass +' select-option' : 'select-option'} onClick={()=>this.selsctClickHandler(item)}>
                {selectedLang.text === item.text ? <span className="bp3-icon bp3-icon-small-tick"></span> 
                  : <span style={{visibility:'hidden'}} className="bp3-icon bp3-icon-small-tick"></span>
                }
                <span className={textClass ? textClass +' select-text':'select-text'}>{item.text ? item.text :''}</span>
                <span className={iconClass ? iconClass +' select-icon':'select-icon'}>{item.icon ? item.icon :''}</span>
              </li>
            )})
          }
          </ul>
        }
      </div>
    );
  }
}

export default Select;